import React, { useCallback } from 'react';

import {
  Container,
  NotificacoesContainer,
  NotificacoesCard,
  Section,
  SectionTitle,
  LidaButton,
} from './styles';

import api from '../../services/api';
import { useNotifications } from '../../context/NotificationContext';
import INotificacoes from '../../routes/vms/INotificacoes';

import { FiCheck } from 'react-icons/fi';

const Notificacoes: React.FC = () => {
  const { notifications, fetchNotifications } = useNotifications();

  const agrupadasPorTipo: Record<string, INotificacoes[]> =
    notifications.reduce((acc, noti) => {
      if (!acc[noti.tipo]) acc[noti.tipo] = [];
      acc[noti.tipo].push(noti);
      return acc;
    }, {} as Record<string, INotificacoes[]>);

  const marcaLida = useCallback(
    async (id: string) => {
      await api.patch(`/notificacoes/marcar-lida/${id}`);

      fetchNotifications();
    },
    [fetchNotifications],
  );

  const formataData = (data: Date): string => {
    const dataNova = new Date(data);

    const dia = dataNova.getDate().toString().padStart(2, '0');
    const mes = (dataNova.getMonth() + 1).toString().padStart(2, '0');

    return `${dia}/${mes}`;
  };

  const verificaData = (data: Date): string => {
    let verificacao = '';

    const dataHoje = new Date();
    const dataAmanha = new Date();
    dataAmanha.setDate(dataAmanha.getDate() + 1);
    const dataAniversario = new Date(data);

    if (
      dataHoje.getDate() === dataAniversario.getDate() &&
      dataHoje.getMonth() === dataAniversario.getMonth()
    ) {
      verificacao = 'HOJE';
    } else if (
      dataAmanha.getDate() === dataAniversario.getDate() &&
      dataAmanha.getMonth() === dataAniversario.getMonth()
    ) {
      verificacao = 'AMANHÃ';
    } else {
      verificacao = 'no dia';
    }

    return verificacao;
  };

  return (
    <Container>
      <h1>Notificações</h1>

      <NotificacoesContainer>
        {Object.entries(agrupadasPorTipo).map(([tipo, lista]) => (
          <Section key={tipo}>
            <SectionTitle>{tipo}</SectionTitle>

            {lista.map((notificacao, index) => (
              <NotificacoesCard key={index}>
                <div>
                  <p>
                    <span>{notificacao.subtitulo}</span> {notificacao.descricao}
                  </p>
                  {notificacao.tipo === '🎂 ANIVERSÁRIO' && (
                    <div>
                      <p>{`${verificaData(notificacao.data)}`}</p>
                      <p>{formataData(notificacao.data)}</p>
                    </div>
                  )}
                </div>

                {notificacao.tipo !== '🎂 ANIVERSÁRIO' && (
                  <LidaButton onClick={() => marcaLida(notificacao.id)}>
                    <FiCheck />
                  </LidaButton>
                )}
              </NotificacoesCard>
            ))}
          </Section>
        ))}
      </NotificacoesContainer>
    </Container>
  );
};

export default Notificacoes;
